import { LDateTime } from '@app/components/date/LDateTime';
import { getAppUserDisplayName } from '@app/helpers/user';
import { InfoM } from '@app/modules/audit/modules/aod/screens/aod-rule-view/components/InfoM';
import { FragmentDuration } from '@app/modules/fragments/components/type/FragmentDuration';
import { Fragment } from '@app/modules/fragments/types';
import { DateTimeStr, UserPublic } from '@mi-front/core';
import { Tags } from '@mi-front/ui';
import { Box } from '@mui/material';
import { FormattedMessage } from 'react-intl';

/**
 * Displays fragment metadata in a vertical list using InfoM (label + value).
 * Used in the fragment view as the right column of the 8/4 grid.
 */
export function FragmentInfoBlock(props: { fragment: Fragment }) {
  const { fragment } = props;

  return (
    <Box>
      <Box display="flex" gap={3}>
        <InfoM label={<FormattedMessage id="fragments.props.date" defaultMessage="Fecha" />}>
          <LDateTime value={fragment.from as DateTimeStr} />
        </InfoM>
        <InfoM label={<FormattedMessage id="common.duration" defaultMessage="Duración" />}>
          <FragmentDuration fragment={fragment} />
        </InfoM>
      </Box>
      <InfoM
        label={<FormattedMessage id="fragments.props.description" defaultMessage="Descripción" />}
      >
        {fragment.description ? (
          <Box component="span" sx={{ whiteSpace: 'pre-wrap' }}>
            {fragment.description.trim()}
          </Box>
        ) : (
          <FormattedMessage
            id="fragments.viewScreen.noDescription"
            defaultMessage="Sin descripción"
          />
        )}
      </InfoM>
      <InfoM label={<FormattedMessage id="fragments.props.tags" defaultMessage="Tags" />}>
        {fragment.tags?.length ? <Tags size="medium" tags={fragment.tags} /> : '-'}
      </InfoM>
      <InfoM
        label={<FormattedMessage id="fragments.props.createdBy" defaultMessage="Creado por" />}
      >
        {fragment.createdBy ? getAppUserDisplayName(fragment.createdBy as UserPublic) : '-'}
      </InfoM>
    </Box>
  );
}
